import { css } from '@emotion/react';
import type { Invitation } from '@zapier/authentication';
import { mediaQueries, useSize } from '@zapier/identity-utils';
import { Avatar, Button, Colors, Typography } from '@zapier/design-system';

type Props = {
  invitation: Invitation;
  handleDeclineButtonClick: () => void;
};

const sectionStyles = css`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const headerStyles = css`
  ${Typography.sectionHeader1Extrabold}
  ${Typography.pageHeader7}
  color: ${Colors.neutral800};
  text-align: center;

  ${mediaQueries.tablet} {
    text-align: left;
  }

  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
`;

const paragraphStyles = css`
  ${mediaQueries.tablet} {
    ${Typography.paragraph3}
    color: ${Colors.neutral700};
  }
  ${mediaQueries.desktop} {
    ${Typography.paragraph1}
    color: ${Colors.neutral700};
    line-height: ${Typography.paragraph1.lineHeight};
  }
`;

export function InvitationPromo({
  invitation,
  handleDeclineButtonClick,
}: Props) {
  const size = useSize();

  function getHeaderText() {
    if (invitation.account.name) {
      return `Join ${invitation.account.name} on Zapier to automate your work.`;
    } else {
      return `You've been invited to join ${invitation.createdBy.full_name}'s account on Zapier.`;
    }
  }

  return (
    <section data-test-id="invitation-promo" css={sectionStyles}>
      {/* @ts-ignore size 80 is not valid but its in the design */}
      <Avatar size={60} url={invitation?.account?.logoUrl} />
      <h1 css={headerStyles}>{getHeaderText()}</h1>
      <p css={paragraphStyles}>
        <b>{invitation?.createdBy.full_name}</b> ({invitation?.createdBy.email})
        invited you to join {invitation?.account.name || 'their account'} on
        Zapier.
      </p>
      <span>
        <Button
          color="secondary"
          onClick={handleDeclineButtonClick}
          isFullWidth={size === 'small'}
        >
          {"I don't know this person"}
        </Button>
      </span>
    </section>
  );
}
